import type { Database } from '@/entities/database';
import type { RequestMeta, ResponseMeta } from '@/shared/api';
import request from '@/shared/api/request';

export const getDatabases = (
  params?: RequestMeta,
): Promise<{
  databases: Database[];
  meta: ResponseMeta;
}> =>
  request({
    url: '/databases/',
    params,
  });
